import React, { useState, useEffect } from 'react';
import { 
  User, Mail, Phone, Edit, Trash2,  ChevronDown, ChevronUp,
  Check, Bike, MessageSquareText, MapPin
} from 'lucide-react';
import '../css/TRB.css';
import axios from 'axios';

const Priceforms = () => {
  const [expandedFormId, setExpandedFormId] = useState(null);
  const [editingFormId, setEditingFormId] = useState(null);
  const [formsData, setFormsData] = useState([]);
  const [editedform, setEditedForm] = useState([]);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await axios('/api/prices');
        setFormsData(response.data);
         console.log('response', response.data);
      } catch(error) {
        console.log('Failed to fetch price form details', error);
      }
    };
    fetchPrices();
  }, []);

 

  const toggleForm = (formId) => {
    console.log('entered toggle');
    console.log('formid', formId);
    if (expandedFormId === formId) {
      console.log('expandedformid', expandedFormId);
      setExpandedFormId(null);
    } else {
      console.log('else part');
      console.log('expandedformid', expandedFormId);
      setExpandedFormId(formId);
      console.log('expandedformid', expandedFormId);
      setEditingFormId(null); // Close edit mode when switching forms
    }
  };

  const handleEdit = (formId) => {
    setEditingFormId(editingFormId === formId ? null : formId);
    const form = formsData.find(f => f._id === formId );
    setEditedForm({...form});
  };

  const handleSave = async(formId) => {
    console.log('entered save function');
    try {
     const res = await axios.put(`/api/pricing/${formId}`, editedform);
     const updated = res.data;

      setFormsData(prev =>
    prev.map(form => (form._id === formId ? updated : form))
  );
    setEditingFormId(null);
    alert('Changes saved successfully!');
    }
   catch(error) {
    console.log('error', error);
    alert('Failed to update');
   }
   
  };

  const handleDelete = async(formId) => {
    if (window.confirm('Are you sure you want to delete this form submission?')) {
      try {
        const res = await axios.delete(`/api/pricedelete/${formId}`);
        console.log('res', res.data);
        setFormsData(prev => prev.filter(form => form._id != formId));
       console.log('Form deleted:', formId);
      alert('Form deleted successfully!');
      } catch(error) {
        console.log('failed to delete', error);
        alert('Failed to delete!');
      }
      
    }
  };



  return (
    <div className="form-details-container">
      {/* Header Section */}
      <div className="forms-header">
        <div className="header-info">
          <h1>Knowing Price forms</h1>
          <p>List of customers who want to know the prices</p>
        </div>
       
      </div>

      {/* Forms List */}
      <div className="forms-list">
        {formsData.map((form) => (
          <div key={form._id} className={`form-card ${expandedFormId === form._id ? 'expanded' : ''}`}>
            {/* Form Card Header - Always Visible */}
            <div className="form-card-header" onClick={() => toggleForm(form._id)}>
              <div className="form-card-left">
                <div className="form-avatar">
                  <User size={24} />
                </div>
                <div className="form-basic-info">
                  <h3 className="form-name">{form.name}</h3>
                  <p className="form-id-text">{form._id}</p>
                </div>
              </div>
              <div className="form-card-right">
               
                <span className="form-submitted-time">{new Date(form.submittedAt).toISOString().split('T')[0]}</span>
                <button className="expand-btn">
                  {expandedFormId === form._id ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                </button>
              </div>
            </div>

            {/* Form Card Details - Expandable */}
            {expandedFormId === form._id && (
              <div className="form-card-details">
                {/* Action Buttons */}
                <div className="detail-actions">
                  <button className="action-btn secondary" onClick={() => handleEdit(form._id)}>
                    <Edit size={16} />
                    {editingFormId === form._id ? 'Cancel' : 'Edit'}
                  </button>
                  
                 
                  <button className="action-btn danger" onClick={() => handleDelete(form._id)}>
                    <Trash2 size={16} />
                    Delete
                  </button>
                </div>

                {/* Personal Information */}
                <div className="details-section">
                  <div className="section-header">
                    <h3>Personal Information</h3>
                    {editingFormId === form._id && (
                      <button className="save-btn" onClick={() => handleSave(editedform._id)}>
                        <Check size={16} />
                        Save
                      </button>
                    )}
                  </div>
                  
                  <div className="details-grid">
                    <div className="detail-item">
                      <div className="detail-label">
                        <User size={16} className="detail-icon" />
                        <span>Full Name</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="text" 
                          className="detail-input" 
                          defaultValue={editedform.name}
                          onChange={e => setEditedForm({ ...editedform, name: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value">{form.name}</div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <Mail size={16} className="detail-icon" />
                        <span>Email</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="email" 
                          className="detail-input" 
                          defaultValue={editedform.email}
                          onChange={e => setEditedForm({ ...editedform, email: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value">
                          <a href={`mailto:${form.email}`} className="link">
                            {form.email}
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <Phone size={16} className="detail-icon" />
                        <span>Phone</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="tel" 
                          className="detail-input" 
                          defaultValue={editedform.phone}
                          onChange={e => setEditedForm({ ...editedform, phone: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value">
                          <a href={`tel:${form.phone}`} className="link">
                            {form.phone}
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <Bike size={16} className="detail-icon" />
                        <span>Selected Variant</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="text" 
                          className="detail-input" 
                          defaultValue={editedform.variant}
                          onChange={e => setEditedForm({ ...editedform, variant: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value">{form.variant}</div>
                      )}
                    </div>

                    <div className="detail-item">
                      <div className="detail-label">
                        <MapPin size={16} className="detail-icon" />
                        <span>State</span>
                      </div>
                      {editingFormId === form._id ? (
                        <input 
                          type="text" 
                          className="detail-input" 
                          defaultValue={form.state}
                          onChange={e => setEditedForm({ ...editedform, state: e.target.value })}
                        />
                      ) : (
                        <div className="detail-value">{form.state}</div>
                      )}
                    </div>

                     

                     

                     

                    
                    
                  </div>
                </div>

               
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Priceforms;


